// TODO: (Taiga UI migration) TuiPopoverService → TuiPortal: constructor args (token, component, defaultOptions) are now abstract class properties; call super(inject(TuiPopupService)).
// Before: @Injectable({useFactory: () => new MyService(TUI_DIALOGS, MyComponent, defaultOpts)}) class MyService extends TuiPopoverService<T, K> {}
// After:  @Injectable({providedIn: "root"}) class MyService extends TuiPortal<T, K> { protected readonly component = MyComponent; protected readonly options = defaultOpts; constructor() { super(inject(TuiPopupService)); } }
// See https://taiga-ui.dev/cdk/portal
import { TuiPortal } from "@taiga-ui/cdk";
import { Inject, Injectable, Injector, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject, of, timer } from 'rxjs';
import { map, switchMap, takeUntil } from 'rxjs/operators';
import { UserLoginReponse } from '../models/user';
import { Router } from '@angular/router';
import { ApiUrlConstants } from '../../shared/constants/api_url_constants';
import { TuiDialogService } from '@taiga-ui/core';
import { TuiPushService } from '@taiga-ui/kit';
import { PolymorpheusComponent } from '@taiga-ui/polymorpheus';
import { SessionExpiryComponent } from '../../auth/components/session-expiry/session-expiry.component';
import { HttpRequestService } from '../../shared/services/http-request.service';
import { CommonService } from '../../shared/services/common.service';
import { loggedInUserViewModel } from '../../admin/models/user-management/user_models';
import { UserManagementService } from '../../admin/services/user-management/user-management.service';
import { ApiResponse } from '../../shared/common-model/common.model';

@Injectable({
  providedIn: 'root',
})
export class AuthService implements OnDestroy {
  public currentUserSubject: BehaviorSubject<UserLoginReponse>;
  public currentUser: Observable<UserLoginReponse>;
  displays: any;
  public sessionExpired = new BehaviorSubject<boolean>(false);
  public TimeDisplay = new BehaviorSubject<any>('');
  public timeDisplays!: Observable<any>;
  public displayMinute = new BehaviorSubject<any>('');
  public displayMinutes!: Observable<any>;
  public timerInterval: any;

  constructor(
    private readonly http: HttpClient,
    private readonly router: Router,
    private readonly httpRequestService: HttpRequestService,
    @Inject(TuiDialogService)
    private readonly dialogService: TuiPortal<any>,
    @Inject(TuiPushService) protected readonly push: TuiPushService,
    private readonly commonService: CommonService,
    private readonly userService: UserManagementService,
    private readonly injector: Injector,
  ) {
    this.currentUserSubject = new BehaviorSubject<UserLoginReponse>(
      JSON.parse(localStorage.getItem('currentUser') || '{}'));
    this.currentUser = this.currentUserSubject.asObservable();
    this.timeDisplays = this.TimeDisplay.asObservable();
    this.displayMinutes = this.displayMinute.asObservable();
  }

  public get currentUserValue(): UserLoginReponse {
    return this.currentUserSubject.value;
  }

  public get timesDisplays(): any {
    return this.timeDisplays;
  }

  login(username: string, password: string) {
    return this.http
      .post<UserLoginReponse>(ApiUrlConstants.login, {
        username,
        password
      }).pipe(map((user) => {
        return user;
      }));
  }

  forgotPasswordSendCode(data: any) {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.forgotPasswordSendCode, data);
  }
  resetPasswordByCode(data: any) {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.resetPasswordByCode, data);
  }
  getToken(): Observable<UserLoginReponse[]> {
    return this.httpRequestService.getData<UserLoginReponse[]>(ApiUrlConstants.getToken);
  }

  logout() {
    localStorage.removeItem('is-so-list');
    localStorage.removeItem('so-view-back-to');
    localStorage.removeItem('token');
    localStorage.removeItem('lang');
    localStorage.removeItem('userId');
    localStorage.removeItem('roleKey');
    localStorage.removeItem('companyInfo');
    localStorage.removeItem('tz');
    localStorage.removeItem('roleDisplayName');
    localStorage.removeItem('currentUser');
    localStorage.removeItem('modules');
    localStorage.removeItem('activeHomeIndex');
    localStorage.removeItem('activeInitiateIndex');
    localStorage.removeItem('activeScopeIndex');
    localStorage.removeItem('activePrepareIndex');
    localStorage.removeItem('isExhibitHouse');

    localStorage.removeItem('defaultProfileCityId');
    localStorage.removeItem('defaultProfileBaseCityId');

    this.router.navigate(['/auth/signin']);
    this.currentUserSubject.next(this.currentUserValue);
    this.commonService.setLoggedInUser(new loggedInUserViewModel());
    return of({ success: false });
  }

  startSessionTimer(timer: number) {
    clearInterval(this.timerInterval);
    this.timer(timer);
  }

  // timer(minute: any) {
  //   let seconds: number = minute * 60;
  //   let textSec: any = '0';
  //   let statSec: number = 60;
  //   const prefix = minute < 10 ? '0' : '';
  //   this.timerInterval = setInterval(() => {
  //     seconds--;
  //     if (statSec != 0) statSec--;
  //     else statSec = 59;
  //     if (statSec < 10) {
  //       textSec = '0' + statSec;
  //     } else textSec = statSec;
  //     this.displays = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;
  //     const displayMinutes = Math.floor(seconds / 60);
  //     console.log(displayMinutes);
  //     this.TimeDisplay.next(this.displays);
  //     if (seconds == 120) {
  //       this.openSessionLogoutAlert(2);
  //     }
  //     if (seconds == 0) {
  //       clearInterval(this.timerInterval);
  //       this.logout();
  //     }
  //   }, 1000);
  // }


  timer(minutes: number) {
    let seconds: number = minutes * 60;
    const prefix = minutes < 10 ? '0' : '';
    const interval = 1000;
    let counter = 0;
    // this.displayMinute.next(`${prefix}${minutes} M`);
    this.timerInterval = setInterval(() => {
      seconds--;
      counter++;

      const displayMinutes = Math.floor(seconds / 60);
      const displaySeconds = seconds % 60;
      const formattedMinutes = displayMinutes < 10 ? `${displayMinutes}` : `${displayMinutes}`;
      const formattedSeconds = displaySeconds < 10 ? `${displaySeconds}` : `${displaySeconds}`;

      // Update display
      this.displays = `${prefix}${formattedMinutes}:${formattedSeconds}`;
      this.TimeDisplay.next(this.displays);
      this.displayMinute.next(`${displayMinutes + 1} M`);
      if (seconds === 120) {
        this.TimeDisplay.next(this.displays);
        this.openSessionLogoutAlert(2);
      }
      if (seconds === 0) {
        clearInterval(this.timerInterval);
        this.logout();
      }
    }, interval);
  }

  getValue() {
    return this.TimeDisplay.asObservable();
  }

  openSessionLogoutAlert(timerValue: any): void {
    this.dialogService
      .open<boolean>(
        new PolymorpheusComponent(SessionExpiryComponent, this.injector),
        {
          data: timerValue,
          size: 'm',
          dismissible: false,
          closeable: false,
        },
      )
      .subscribe((confirmed: boolean) => {
        if (confirmed) {
          clearInterval(this.timerInterval);

          if (this.currentUserValue?.success) {
            this.refreshToken();
          }
        }
      });
  }
  refreshToken() {
    this.getToken().subscribe({
      next: (res: any) => {
        if (res.success) {
          clearInterval(this.timerInterval);
          this.currentUserValue.accessToken = "";
          localStorage.setItem('token', res.data);
          this.timer(this.currentUserValue.expInMintNormalUser);
        }
        else {
          this.logout();
        }
      },
      error: (error) => {

      }
    });
  }

  ngOnDestroy() {
    clearInterval(this.timerInterval);
  }

  getLoggedInUserDetails(): Observable<loggedInUserViewModel> {
    return this.httpRequestService.getData<loggedInUserViewModel>(ApiUrlConstants.GetLoggedInUserDetails);
  }
}
